import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var MOBILE_BREAKPOINT = 480;
export var useMediaQuery = function useMediaQuery() {
  var minWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MOBILE_BREAKPOINT;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMatchingWidth = _useState2[0],
    setIsMatchingWidth = _useState2[1];
  useEffect(function () {
    // This code will only run in the browser
    if (typeof window !== 'undefined') {
      var handleResize = function handleResize() {
        setIsMatchingWidth(window.innerWidth < minWidth);
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [minWidth]);
  return isMatchingWidth;
};